import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { onAuthStateChange, getCurrentUser } from './lib/cloudflare';
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Privacy from './pages/Privacy/Privacy';
import Service from './pages/Service/Service';
import LoadingScreen from './components/Loading';
import './styles/App.css';

function App() {
  const { isAuthenticated, isLoading, setAuthState, setUser } = useAuthStore();

  useEffect(() => {
    // 초기 사용자 로드
    const user = getCurrentUser();
    if (user) {
      setUser(user);
      setAuthState(true, false);
    } else {
      setAuthState(false, false);
    }

    // 인증 상태 변경 리스너
    const unsubscribe = onAuthStateChange((user) => {
      if (user) {
        setUser(user);
        setAuthState(true, false);
      } else {
        setAuthState(false, false);
      }
    });

    return () => unsubscribe();
  }, [setAuthState, setUser]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} 
        />
        <Route 
          path="/dashboard" 
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} 
        />
        <Route 
          path="/privacy" 
          element={<Privacy />} 
        />
        <Route 
          path="/service" 
          element={<Service />} 
        />
        <Route 
          path="/" 
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} 
        />
      </Routes>
    </Router>
  );
}

export default App; 